import styled from 'styled-components';

import { colors } from 'theme/colors';

export const SideBarContainer = styled.div<{ height: number }>`
  display: flex;
  height: ${({ height }) => height}px;
  position: sticky;
  top: 0;
`;

export const SideBarProducts = styled.div`
  background: ${({ theme }) => theme.sidebar.main};
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(255, 255, 255, 0.12);
  overflow-y: auto;
`;

export const LogoItem = styled.div`
  margin: 20px auto;
  width: 30px;
  height: 30px;
`;

export const StyledLine = styled.hr`
  width: 51px;
  border: 1px solid rgba(255, 255, 255, 0.12);
`;

export const SubSideBarProducts = styled.div<{ $collapsed: boolean }>`
  width: ${(props) => (props.$collapsed ? '0' : '261px')};
  transition: width 0.5s ease-in-out;
  background: ${({ theme }) => theme.sidebar.submenu};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  > * {
    visibility: ${(props) => (props.$collapsed ? 'hidden' : 'visible')};
  }
`;

export const CompanyLogoContainer = styled.div<{ $collapsed: boolean }>`
  display: flex;
  height: 65px;
  align-items: center;
  gap: 15px;
  align-self: stretch;
  background: ${({ theme }) => theme.sidebar.main};
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-right: ${(props) => props.$collapsed && 'none'};
  border-left: none;
  border-top: none;
  padding: 20px;
  opacity: ${(props) => (props.$collapsed ? '0' : '1')};
  transition: opacity 0.5s ease-in-out;
`;

export const SubSideBarTitle = styled.p`
  color: ${colors.common.white};
  font-size: 20px;
  font-weight: 500;
  padding: 20px 20px 10px;
  margin: 0;
`;

export const SubItemsList = styled.div<{ $collapsed: boolean }>`
  width: 100%;
  opacity: ${(props) => (props.$collapsed ? '0' : '1')};
  transition: opacity 0.3s ease-in-out;
  overflow-y: auto;
  overflow-x: hidden;
`;
